var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2284 7.44C11.0242 7.44 10.8273 7.52103 10.6812 7.66716C10.5349 7.81349 10.4516 8.01318 10.4516 8.22261V17.6334C10.4504 22.3715 11.744 27.0196 14.1921 31.0751C16.5737 35.0203 19.9595 38.2587 23.9999 40.4617C28.0398 38.258 31.4251 35.0194 33.8066 31.0743C36.2546 27.0189 37.5486 22.3714 37.5484 17.6335V8.22261C37.5484 8.01318 37.4651 7.81349 37.3188 7.66716C37.1727 7.52103 36.9758 7.44 36.7716 7.44H11.2284ZM9.6506 6.65305C10.068 6.23559 10.6355 6 11.2284 6H36.7716C37.3645 6 37.932 6.23559 38.3494 6.65305C38.7666 7.07031 39 7.635 39 8.22261V17.6334C39 17.6334 39 17.6334 39 17.6334C39.0002 22.6313 37.6353 27.5347 35.052 31.8141C32.4687 36.0936 28.765 39.5869 24.3402 41.916C24.1275 42.028 23.8727 42.028 23.6599 41.9161C19.2344 39.5877 15.5302 36.0946 12.9467 31.8149C10.3633 27.5353 8.99878 22.6315 9 17.6334C9 17.6334 9 17.6335 9 17.6334V8.22261C9 7.635 9.23336 7.0703 9.6506 6.65305ZM32.7941 15.9921C33.0688 16.2817 33.0548 16.7373 32.7629 17.0098L21.4938 27.5281C21.2073 27.7955 20.7582 27.7878 20.4811 27.5108L16.7248 23.7542C16.4425 23.4719 16.4443 23.0161 16.7289 22.736C17.0135 22.456 17.473 22.4578 17.7553 22.7401L21.0139 25.9988L31.7681 15.9611C32.0601 15.6886 32.5194 15.7025 32.7941 15.9921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.18e9811331bb17a1d6113e0be7d07405.svg";
export { ForwardRef as ReactComponent };